export default function Button({
  size = "md",
  type = "color",
  width = "fit",
  desktopWidth = null,
  text = "Button",
  textColor = null,
  onClick = null,
  icon = null,
  licon = null,
  ricon = null,
  disabled = false,
}) {
  /*
    size: sm, md, lg, xl
    state: default, hover, active, disabled
    type: color, outline, bw, error
    width: fit, full
    desktopWidth: fit, full (opzionale, se non presente usa width)
  */

  // Determina le classi di dimensione in base alla presenza di un'icona
  let sizeClasses;
  if (icon) {
    sizeClasses = {
      sm: "p-[6px] rounded-[6px]",
      md: "p-[10px] rounded-[8px]",
      lg: "p-[12px] rounded-[8px]",
    };
  } else {
    sizeClasses = {
      xs: "px-[8px] py-[4px] text-12 rounded-[8px] gap-[12px]",
      sm: "px-[12px] py-[10px] text-12 rounded-[8px] gap-[6px]",
      md: "px-[18px] py-[12px] text-16 rounded-[8px] gap-[8px]",
      lg: "px-[24px] py-[16px] text-20 rounded-[12px] gap-[12px]",
      xl: "px-[28px] py-[22px] text-24 rounded-[12px] gap-[14px]",
    };
  }

  // Gestione dei tipi di bottone
  const typeClasses = {
    color:
      "bg-accent text-white border-2 border-transparent hover:border-accent-dark active:bg-accent-dark",
    outline:
      "border-2 border-accent text-accent bg-transparent hover:bg-accent hover:bg-opacity-[0.33] active:text-accent-dark active:border-accent-dark",
    bw: "bg-white text-black border-2 border-gray-100 hover:border-gray-200 active:border-black",
    error:
      "bg-white bg-error text-error border-2 border-error",
  };

  // Definizione delle classi di larghezza
  const widthClasses = {
    fit: "w-fit",
    full: "w-full",
  };

  const mobileWidthClass = widthClasses[width] || widthClasses.fit;
  const desktopWidthClass = desktopWidth
    ? `md:${widthClasses[desktopWidth] || widthClasses.fit}`
    : "";

  if (icon) {
    return (
      <button
        onClick={onClick}
        className={`w-fit h-fit ${typeClasses[type]} ${sizeClasses[size]}  ${disabled ? "opacity-50 cursor-not-allowed pointer-events-none" : ""}`}
      >
        {icon}
      </button>
    );
  }

  return (
    <button
      className={`font-md flex whitespace-nowrap items-center justify-center ${mobileWidthClass} ${desktopWidthClass} ${sizeClasses[size]} ${typeClasses[type]} transition-all ${disabled ? "opacity-50 cursor-not-allowed pointer-events-none" : ""
        } text-${textColor}`} // Applica il colore del testo
      onClick={onClick}
    >
      {licon && <span>{licon}</span>}
      {text}
      {ricon && <span>{ricon}</span>}
    </button>
  );
}
